import { Log } from './log';
export default new Log({
  id: '@probe.gl/log'
});
export { Log } from './log';
export { COLOR } from './utils/color';
export { addColor } from './utils/color';
export { leftPad, rightPad } from './utils/formatters';
export { autobind } from './utils/autobind';
export { LocalStorage } from './utils/local-storage';
export { getHiResTimestamp } from './utils/hi-res-timestamp';
import './init';
//# sourceMappingURL=index.js.map